import highlightUtil from '@/lib/highlightUtil'

/**
 * ハイライトに関わる処理をまとめたmixin
 */
export default {
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  },
  methods: {
    // 画面にハイライトを付与する。マウント時に呼び出す。
    setHighlight (commentHighlight) {
      if (!commentHighlight.highlight) return // ハイライト情報がない場合は描画不要
      const element = document.getElementById(commentHighlight.target)
      if (!element) return // ハイライト箇所が取得できない場合は描画不要
      // ハイライトの重複生成を防止
      const isExistMarkedHighlightId = Array.from(element.childNodes).some(childNode => {
        return childNode.nodeName === 'MARK' && childNode.id === highlightUtil.createHighlightId(commentHighlight.target, commentHighlight.highlight.start)
      })
      if (isExistMarkedHighlightId) return
      // エリアハイライトとテキストハイライト切り分け
      if (highlightUtil.isAreaHighlight(commentHighlight.target)) {
        this.setAreaHighlight(commentHighlight, element)
        return
      }
      this.setTextHighlight(commentHighlight, element)
    },

    // 画像ハイライト設定
    setAreaHighlight (commentHighlight, element) {
      const newHighlight = highlightUtil.areaHighlight(element, highlightUtil.getHighlightClass(commentHighlight.isCompanyStaff))
      if (!newHighlight) return
      newHighlight.id = highlightUtil.createHighlightId(commentHighlight.target, commentHighlight.highlight.start)
    },

    // テキストハイライト
    setTextHighlight (commentHighlight, element) {
      const highlightRange = highlightUtil.getTargetRange(commentHighlight, element)
      if (!highlightRange) return
      // ハイライトの付与（DOM書き換え）
      const newHighlight = document.createElement('mark')
      // - ハイライト色の判定
      let highlightClass = highlightUtil.highlightClass.change // 初期値：「文字列に変更あり」クラス
      let highlightTargetText = highlightRange.toString()
      highlightTargetText = highlightUtil.truncateHighlightText(highlightTargetText)
      if (highlightTargetText === commentHighlight.targetText) {
        // 文字列に変更がない場合は、ハイライトクラスを各ロールの色にする
        highlightClass = highlightUtil.getHighlightClass(commentHighlight.isCompanyStaff)
      }
      // - ハイライト色クラス付与
      newHighlight.className = 'pega-highlight ' + highlightClass
      newHighlight.id = highlightUtil.createHighlightId(commentHighlight.target, commentHighlight.highlight.start)

      newHighlight.appendChild(highlightRange.extractContents())
      highlightRange.insertNode(newHighlight)
    }
  }
}
